import PageHeader from '../../components/PageHeader'
import { getTranslate } from '../../localization'
import { RoomtypeAddHeader } from './RoomtypeAddHeader'
import RoomtypeMainForm from './RoomtypeMainForm'

const RoomtypeForm = () => {
  return (
    <div>
      <PageHeader title={getTranslate('RoomType')} />
      <RoomtypeAddHeader />
      <RoomtypeMainForm />
    </div>
  )
}

export default RoomtypeForm
